/**
 * Affichage téléphone (lecture seule — pas d'écriture DB).
 * FR → "07 69 36 62 50" (espaces). International → forme sûre (+…) sans inventer de préfixe FR.
 *
 * @param {unknown} input
 * @returns {string|null|undefined}
 */
export function formatPhoneDisplay(input) {
  if (input == null) return input;
  const raw = String(input).trim();
  if (!raw) return raw;

  const compact = raw.replace(/[\s.\-()/]/g, '');
  let digitsOnly = compact.replace(/\D/g, '');

  // 0033… → traité comme +33…
  if (compact.startsWith('00') && digitsOnly.startsWith('00')) {
    digitsOnly = digitsOnly.slice(2);
  }

  let national = null;

  if (/^0[1-9]\d{8}$/.test(digitsOnly)) {
    national = digitsOnly;
  } else if (/^33[1-9]\d{8}$/.test(digitsOnly)) {
    national = `0${digitsOnly.slice(2)}`;
  }

  if (national && /^0[1-9]\d{8}$/.test(national)) {
    return national.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  }

  if (compact.startsWith('+')) {
    return `+${digitsOnly}`;
  }
  if (raw.startsWith('00') && digitsOnly.length >= 8) {
    return `+${digitsOnly}`;
  }

  return raw;
}
